import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "disablePage" }
const _hoisted_2 = { id: "tilbud" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pdf_viewer = _resolveComponent("pdf-viewer")!
  const _component_buttons_for_offer_view = _resolveComponent("buttons-for-offer-view")!
  const _component_comment_section = _resolveComponent("comment-section")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "spinner" }, null, -1 /* CACHED */)
    ]))], 512 /* NEED_PATCH */), [
      [_vShow, !_ctx.siteIsInitialized]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_pdf_viewer),
      _createVNode(_component_buttons_for_offer_view),
      _createVNode(_component_comment_section)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}